// Coordenadas (%) de cada destino sobre el mapamundi ilustrado (imagen del cliente)
export const MAP_COORDS = {
  MEX: { x: 19, y: 40 },
  CUN: { x: 23.5, y: 41 },
  NYC: { x: 27.5, y: 30 },
  TYO: { x: 83, y: 30 },
  PAR: { x: 47, y: 28 },
  RIO: { x: 31, y: 70 },
  LDN: { x: 45, y: 25 },
  SEL: { x: 79, y: 31 },
  CUZ: { x: 26, y: 64 },
  DXB: { x: 57, y: 40 },
  BCN: { x: 46, y: 31 },
  MDE: { x: 26, y: 53 },
};
